import React, { ReactNode } from 'react';
import { Button } from 'reactstrap';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import StyledTitle from 'Shared/components/StyledTitle/StyledTitle';
import CsrfInput from 'Dashboard/components/CsrfInput/CsrfInput';

import './OnboardingFormWrapper.scss';

type Props = {
  title: string;
  children: ReactNode;
  actionPath: string;
  submitText: string;
  footerComponent?: ReactNode;
};

function OnboardingFormWrapper({ title, children, actionPath, submitText, footerComponent = null }: Props) {
  return (
    <div className="onboarding-form-wrapper w-100 p-sm-4 d-flex flex-column align-items-center justify-content-center">
      <div className="onboarding-form-wrapper-content d-flex flex-column justify-content-center align-items-center">
        <CharmaLogo width="180" className="mb-2 mt-4" />
        <StyledTitle>{title}</StyledTitle>
        <div className="user-password-new-container w-100 p-4">
          <form action={actionPath} method="POST">
            <CsrfInput />
            {children}
            <Button color="primary" type="submit" className="w-100 py-2 mt-2">
              {submitText}
            </Button>
          </form>
        </div>
        {footerComponent}
      </div>
    </div>
  );
}

export default OnboardingFormWrapper;
